(function () {
    'use strict';

    document.addEventListener('DOMContentLoaded', function () {
        window.isRTL = document.documentElement.getAttribute('dir') === 'rtl';

        //Handle password form
        const passwordForm = document.querySelector('[data-password-form]');
      
        if (passwordForm) {

            if (!passwordForm.hasAttribute('data-wrong-password')) {
                let json = sessionStorage.getItem('store-password');
               
                if (json && typeof json["attributes[_shop_password]"] !== 'undefined') {
                    let jsonData = JSON.parse(json);
                    let data = new URLSearchParams();
                    Object.keys(jsonData).forEach(key => {
                        data.append(key, jsonData[key]);
                    });
                    fetch('/cart/update.js', {
                        method: 'post',
                        body: data,
                    })
                        .then(response => {
                           console.log(response)
                            if (response.ok) {
                                window.location.reload();
                            }
                            else {
                                sessionStorage.removeItem('store-password');
                            }
                        });
                }
            }

            
            passwordForm.addEventListener('submit', event => {
                event.preventDefault();
                let data = new URLSearchParams();
                let jsonData = {};
                for (const pair of new FormData(event.target)) {
                    data.append(pair[0], pair[1]);
                    jsonData[pair[0]] = pair[1];
                }
              
                fetch('/cart/update.js', {
                    method: 'post',
                    body: data,
                })
                    .then(() => { 
                        sessionStorage.setItem('store-password', JSON.stringify(jsonData));
                        window.location.reload();
                    });
            });
        }
        
    });

})();
